function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.75 5.75H4.75V7.25H7.75V5.75ZM4.75 5H7.75C8.17188 5 8.5 5.34375 8.5 5.75V7.25C8.5 7.67188 8.17188 8 7.75 8H4.75C4.34375 8 4 7.67188 4 7.25V5.75C4 5.34375 4.34375 5 4.75 5ZM11.25 5.75H10.25V9.75H11.25V5.75ZM10.25 5H11.25C11.6719 5 12 5.34375 12 5.75V9.75C12 10.1719 11.6719 10.5 11.25 10.5H10.25C9.84375 10.5 9.5 10.1719 9.5 9.75V5.75C9.5 5.34375 9.84375 5 10.25 5ZM5.75 9.75V10.75H7.75V9.75H5.75ZM5 9.75C5 9.34375 5.34375 9 5.75 9H7.75C8.17188 9 8.5 9.34375 8.5 9.75V10.75C8.5 11.1719 8.17188 11.5 7.75 11.5H5.75C5.34375 11.5 5 11.1719 5 10.75V9.75Z",
  fill: "currentColor"
});

function SvgViewDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDashboardIcon);
export default __webpack_public_path__ + "static/media/view-dashboard-icon.a82de373.svg";
export { ForwardRef as ReactComponent };